import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-priority-processing',
  imports: [UpsellCardComponent],
  templateUrl: './priority-processing.component.html',
})
export class PriorityProcessingComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.PriorityProcessing;
}
